/* American MRE Supply v10
   Cart drawer (Shopify Cart API) + Lower 48 ZIP check.
   Vanilla JS, no dependencies. Safe to load with `defer`. */
(function () {
  'use strict';

  /* ------------------------------------------------------------------ */
  /* Lower 48 ZIP check                                                  */
  /* ------------------------------------------------------------------ */
  function classifyZip(zip) {
    if (!/^\d{5}$/.test(zip)) return 'format';
    var p = parseInt(zip.slice(0, 3), 10);
    if (p >= 6 && p <= 9) return 'territory';     // Puerto Rico, U.S. Virgin Islands
    if (p >= 90 && p <= 99) return 'military';    // APO/FPO (AE)
    if (p === 340) return 'military';             // APO/FPO (AA)
    if (p >= 962 && p <= 966) return 'military';  // APO/FPO (AP)
    if (p >= 967 && p <= 968) return 'hawaii';
    if (p === 969) return 'territory';            // Guam and Pacific territories
    if (p >= 995 && p <= 999) return 'alaska';
    if (p <= 4) return 'unknown';
    return 'ok';
  }

  var ZIP_TEXT = {
    format: 'Enter a 5-digit U.S. ZIP code.',
    unknown: 'We could not recognize that ZIP code. Check the number and try again.',
    alaska: 'Not available. We deliver to the contiguous 48 states only, so we cannot ship to Alaska.',
    hawaii: 'Not available. We deliver to the contiguous 48 states only, so we cannot ship to Hawaii.',
    territory: 'Not available. We deliver to the contiguous 48 states only, so we cannot ship to U.S. territories.',
    military: 'Not available. We deliver to the contiguous 48 states only, so we cannot ship to APO/FPO military addresses.'
  };

  function runZipCheck(root) {
    var input = root.querySelector('[data-ams-zip-input]');
    var msg = root.querySelector('[data-ams-zip-msg]');
    if (!input || !msg) return;
    var zip = input.value.replace(/\D/g, '').slice(0, 5);
    input.value = zip;
    var result = classifyZip(zip);
    root.setAttribute('data-state', result === 'ok' ? 'ok' : 'error');
    msg.textContent = result === 'ok'
      ? 'Delivery available. ZIP ' + zip + ' is inside our free shipping area (the contiguous 48 states). Final details are confirmed at checkout.'
      : ZIP_TEXT[result];
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-ams-zip-button]');
    if (!button) return;
    runZipCheck(button.closest('[data-ams-zip]'));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target.closest && event.target.closest('[data-ams-zip-input]');
    if (!input) return;
    // The product page ZIP box must never submit an enclosing form (add to cart).
    event.preventDefault();
    runZipCheck(input.closest('[data-ams-zip]'));
  });

  document.addEventListener('input', function (event) {
    var input = event.target.closest && event.target.closest('[data-ams-zip-input]');
    if (!input) return;
    var clean = input.value.replace(/\D/g, '').slice(0, 5);
    if (clean !== input.value) input.value = clean;
  });

  /* ------------------------------------------------------------------ */
  /* Cart drawer                                                         */
  /* ------------------------------------------------------------------ */
  var dlg, bodyEl, footerEl, countEl, subtotalEl, noteEl, statusEl, checkoutEl;
  var urls = {};
  var lastTrigger = null;
  var noteDirty = false;
  var noteSaving = null;
  var cartCurrency = 'USD';

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function sized(url, width) {
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function say(text) {
    if (statusEl) statusEl.textContent = text || '';
  }

  function requestJson(url, options) {
    options = options || {};
    options.credentials = 'same-origin';
    options.headers = Object.assign({ Accept: 'application/json' }, options.headers || {});
    return fetch(url, options).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
        }
        return data;
      });
    });
  }

  function postJson(url, payload) {
    return requestJson(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
  }

  function updateBadges(count) {
    var badges = document.querySelectorAll('.ams-header__cart b');
    for (var i = 0; i < badges.length; i++) badges[i].textContent = String(count);
    if (countEl) countEl.textContent = count > 0 ? '(' + count + ')' : '';
  }

  function lineNode(item) {
    var li = el('li', 'ams-cart__line');
    li.setAttribute('data-key', item.key);

    var media = el('a', 'ams-cart__media');
    media.href = item.url;
    media.setAttribute('tabindex', '-1');
    media.setAttribute('aria-hidden', 'true');
    if (item.image) {
      var img = new Image();
      img.src = sized(item.image, 160);
      img.width = 80;
      img.height = 80;
      img.alt = '';
      img.loading = 'lazy';
      media.appendChild(img);
    }
    li.appendChild(media);

    var info = el('div', 'ams-cart__info');
    var title = el('a', 'ams-cart__item-title', item.product_title);
    title.href = item.url;
    info.appendChild(title);

    if (item.variant_title) info.appendChild(el('p', 'ams-cart__meta', item.variant_title));
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
      info.appendChild(el('p', 'ams-cart__meta', item.selling_plan_allocation.selling_plan.name));
    }
    if (item.properties) {
      Object.keys(item.properties).forEach(function (key) {
        var value = item.properties[key];
        if (key.charAt(0) === '_' || value === '' || value == null) return;
        info.appendChild(el('p', 'ams-cart__meta', key + ': ' + value));
      });
    }

    var price = el('p', 'ams-cart__price');
    if (item.original_line_price > item.final_line_price) {
      price.appendChild(el('s', 'ams-cart__was', money(item.original_line_price, cartCurrency)));
      price.appendChild(document.createTextNode(' '));
    }
    price.appendChild(el('span', null, money(item.final_line_price, cartCurrency)));
    info.appendChild(price);

    var controls = el('div', 'ams-cart__controls');
    var qty = el('div', 'ams-cart__qty');
    qty.setAttribute('role', 'group');
    qty.setAttribute('aria-label', 'Quantity for ' + item.product_title);

    var minus = el('button', 'ams-cart__qty-btn', '−');
    minus.type = 'button';
    minus.setAttribute('data-ams-qty', '-1');
    minus.setAttribute('aria-label', 'Decrease quantity');

    var input = el('input', 'ams-cart__qty-input');
    input.type = 'number';
    input.min = '0';
    input.value = String(item.quantity);
    input.setAttribute('inputmode', 'numeric');
    input.setAttribute('aria-label', 'Quantity');
    input.setAttribute('data-ams-qty-input', '');

    var plus = el('button', 'ams-cart__qty-btn', '+');
    plus.type = 'button';
    plus.setAttribute('data-ams-qty', '1');
    plus.setAttribute('aria-label', 'Increase quantity');

    qty.appendChild(minus);
    qty.appendChild(input);
    qty.appendChild(plus);
    controls.appendChild(qty);

    var remove = el('button', 'ams-cart__remove', 'Remove');
    remove.type = 'button';
    remove.setAttribute('data-ams-remove', '');
    remove.setAttribute('aria-label', 'Remove ' + item.product_title + ' from cart');
    controls.appendChild(remove);

    info.appendChild(controls);
    li.appendChild(info);
    return li;
  }

  function render(cart) {
    cartCurrency = cart.currency || 'USD';
    bodyEl.textContent = '';
    bodyEl.removeAttribute('aria-busy');
    updateBadges(cart.item_count);

    if (!cart.item_count) {
      var empty = el('div', 'ams-cart__empty');
      empty.appendChild(el('p', null, 'Your cart is empty.'));
      var shop = el('a', 'ams-cart__shop', 'Shop MREs');
      shop.href = urls.shop;
      empty.appendChild(shop);
      bodyEl.appendChild(empty);
      footerEl.hidden = true;
      return;
    }

    var list = el('ul', 'ams-cart__lines');
    cart.items.forEach(function (item) { list.appendChild(lineNode(item)); });
    bodyEl.appendChild(list);

    subtotalEl.textContent = money(cart.total_price, cartCurrency);
    if (noteEl && !noteDirty) noteEl.value = cart.note || '';
    footerEl.hidden = false;
  }

  function showError(error) {
    say(error && error.message ? error.message : 'Something went wrong. Please try again.');
  }

  function refresh() {
    bodyEl.setAttribute('aria-busy', 'true');
    return requestJson(urls.cart).then(render).catch(function (error) {
      bodyEl.textContent = '';
      bodyEl.removeAttribute('aria-busy');
      var fail = el('div', 'ams-cart__empty');
      fail.appendChild(el('p', null, 'We could not load your cart.'));
      var link = el('a', 'ams-cart__shop', 'Open the full cart page');
      link.href = urls.cartPage;
      fail.appendChild(link);
      bodyEl.appendChild(fail);
      footerEl.hidden = true;
      showError(error);
    });
  }

  function setQuantity(key, quantity) {
    say('Updating cart…');
    bodyEl.setAttribute('aria-busy', 'true');
    return postJson(urls.change, { id: key, quantity: Math.max(0, quantity) })
      .then(function (cart) {
        render(cart);
        say(quantity === 0 ? 'Item removed.' : 'Cart updated.');
      })
      .catch(function (error) {
        showError(error);
        return refresh();
      });
  }

  function saveNote() {
    if (!noteEl || !noteDirty) return Promise.resolve();
    noteSaving = postJson(urls.update, { note: noteEl.value }).then(function () {
      noteDirty = false;
    }).catch(showError);
    return noteSaving;
  }

  function open(trigger) {
    if (!api.enabled()) return Promise.resolve();
    lastTrigger = trigger || document.activeElement;
    if (!dlg.open) {
      dlg.showModal();
      document.documentElement.classList.add('ams-cart-lock');
    }
    say('');
    return refresh();
  }

  function close() {
    if (dlg && dlg.open) dlg.close();
  }

  var api = {
    enabled: function () {
      return !!(dlg && typeof dlg.showModal === 'function');
    },
    open: open,
    close: close,
    refresh: refresh
  };
  window.AmsCartDrawer = api;

  function initCart() {
    dlg = document.querySelector('[data-ams-cart]');
    if (!dlg) return;
    bodyEl = dlg.querySelector('[data-ams-cart-body]');
    footerEl = dlg.querySelector('[data-ams-cart-footer]');
    countEl = dlg.querySelector('[data-ams-cart-count]');
    subtotalEl = dlg.querySelector('[data-ams-cart-subtotal]');
    noteEl = dlg.querySelector('[data-ams-cart-note]');
    statusEl = dlg.querySelector('[data-ams-cart-status]');
    checkoutEl = dlg.querySelector('[data-ams-cart-checkout]');
    urls = {
      cart: dlg.getAttribute('data-cart-url'),
      change: dlg.getAttribute('data-change-url'),
      update: dlg.getAttribute('data-update-url'),
      shop: dlg.getAttribute('data-shop-url'),
      cartPage: dlg.getAttribute('data-cart-url').replace(/\.js$/, ''),
      checkout: dlg.getAttribute('data-checkout-url')
    };

    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('ams-cart-lock');
      if (lastTrigger && document.contains(lastTrigger) && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    });

    // Click on the dimmed area (the dialog itself, outside the panel) closes the drawer.
    dlg.addEventListener('click', function (event) {
      if (event.target === dlg) close();
    });

    dlg.addEventListener('click', function (event) {
      var target = event.target;
      if (target.closest('[data-ams-cart-close]')) { close(); return; }

      var step = target.closest('[data-ams-qty]');
      var drop = target.closest('[data-ams-remove]');
      if (!step && !drop) return;
      var line = target.closest('.ams-cart__line');
      if (!line) return;
      var input = line.querySelector('[data-ams-qty-input]');
      var current = parseInt(input.value, 10) || 0;
      var next = drop ? 0 : current + parseInt(step.getAttribute('data-ams-qty'), 10);
      setQuantity(line.getAttribute('data-key'), next);
    });

    dlg.addEventListener('change', function (event) {
      var input = event.target.closest && event.target.closest('[data-ams-qty-input]');
      if (input) {
        var line = input.closest('.ams-cart__line');
        setQuantity(line.getAttribute('data-key'), parseInt(input.value, 10) || 0);
        return;
      }
      if (event.target === noteEl) {
        noteDirty = true;
        saveNote();
      }
    });

    // Make sure a typed note is saved before the browser leaves for checkout.
    checkoutEl.addEventListener('click', function (event) {
      if (!noteDirty && !noteSaving) return;
      event.preventDefault();
      Promise.resolve(noteDirty ? saveNote() : noteSaving).then(function () {
        window.location.href = urls.checkout;
      });
    });

    // The header cart link opens the drawer; it still works as a normal link without JS.
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a.ams-header__cart');
      if (!link || event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      open(link);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCart);
  else initCart();
})();
